import { QuestionDetailGetRandomList, QuestionDetailInsert, QuestionDetailInsertMany, QuestionDetailDelete, QuestionDetailUpdate, QuestionDetailGetById, QuestionDetailGetList, QuestionDetailGetPageList } from "@/api/questiondetail/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 获取列表
    QuestionDetailGetRandomList(context, payload) {
        return new Promise((resolve, reject) => {
            QuestionDetailGetRandomList(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    QuestionDetailInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            QuestionDetailInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    QuestionDetailInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            QuestionDetailInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    QuestionDetailUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionDetailUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    QuestionDetailGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionDetailGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    QuestionDetailGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionDetailGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    QuestionDetailGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionDetailGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}